module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.products) ? _c('div', {
    staticClass: "impact-container",
    attrs: {
      "id": "impact-project"
    }
  }, [_c('Card', {
    staticClass: "main-card",
    attrs: {
      "product": _vm.products[0],
      "wide": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "cards-wrapper"
  }, _vm._l((_vm.products.slice(1)), function(item, index) {
    return _c('Card', {
      key: index,
      attrs: {
        "product": item
      }
    })
  }))], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9c754f2a","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-webpack-plugin/loader.js?id=1udq9m5yalv!./~/string-replace-webpack-plugin/loader.js?id=5v3roo83miv!./src/components/impact-project/ImpactProject.vue
// module id = 786
// module chunks = 0